<div class="app-popover-template">
  <p *ngIf="data?.title" class="popover-title">{{ data.title }}</p>
  <p>{{ data?.message }}</p>
</div>
